export const DEFAULT_REGION = process.env.AWS_REGION || 'us-east-2';
